var React = require('react');

function CloseButtonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.8355 1.70416C23.2244 1.31202 23.2218 0.678863 22.8296 0.289963C22.4375 -0.098936 21.8043 -0.0963071 21.4154 0.295835L11.5627 10.2307L1.71004 0.295835C1.32114 -0.0963071 0.687978 -0.098936 0.295835 0.289963C-0.0963071 0.678863 -0.098936 1.31202 0.289963 1.70416L10.1544 11.6508L0.289963 21.5975C-0.098936 21.9896 -0.0963071 22.6228 0.295835 23.0117C0.687978 23.4006 1.32114 23.3979 1.71004 23.0058L11.5627 13.0709L21.4154 23.0058C21.8043 23.3979 22.4375 23.4006 22.8296 23.0117C23.2218 22.6228 23.2244 21.9896 22.8355 21.5975L12.9711 11.6508L22.8355 1.70416Z","fill":"currentColor"}));
}

CloseButtonIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseButtonIcon;

CloseButtonIcon.default = CloseButtonIcon;
